import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_AUTH__SUCCESS,
  ACTION_AUTH__FAIL,
  ACTION_LOGIN__REQUEST,
  ACTION_LOGIN__SUCCESS,
  ACTION_LOGIN__FAIL,
  ACTION_LOGOUT__SUCCESS,
} from '../actionTypes';


const data = (state = null, action) => {
  switch (action.type) {
    case ACTION_AUTH__SUCCESS:
    case ACTION_LOGIN__SUCCESS:
      return action.payload;

    case ACTION_LOGIN__FAIL:
    case ACTION_AUTH__FAIL:
      return null;

    case ACTION_LOGOUT__SUCCESS:
      return {};

    default:
      return state;
  }
};

const isLoginRequestSending = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOGIN__SUCCESS:
    case ACTION_LOGIN__FAIL:
      return false;

    case ACTION_LOGIN__REQUEST: {
      return true;
    }

    default:
      return state;
  }
};

export default combineReducers({
  data,
  isLoginRequestSending,
  errors,
});
